import React from "react"
import propTypes from "prop-types"

import ErrorMessage from "../ErrorMessage"

const Checkbox = ({ field, onChange, isSubmitted, className }) => {
  return (
    <div
      className={`form_checkbox ${className}${
        isSubmitted && !!field.message && field.required ? " is-invalid" : ""
      }`}
    >
      <input
        type={field.type}
        id={field.name}
        checked={field.checked ? "checked" : ""}
        name={field.name}
        value={field.value}
        onChange={e => onChange(field.name, "checked", e.target.checked)}
      />

      <label htmlFor={field.name}>
        <div className="form_checkbox_text">{field.label}</div>
      </label>

      <ErrorMessage message={field.message} />
    </div>
  )
}

Checkbox.propTypes = {
  field: propTypes.shape({
    label: propTypes.string.isRequired,
    name: propTypes.string.isRequired,
    type: propTypes.string.isRequired,
    value: propTypes.string,
    checked: propTypes.bool.isRequired,
    message: propTypes.string,
    required: propTypes.bool.isRequired,
    class: propTypes.string
  }).isRequired,
  onChange: propTypes.func.isRequired,
  isSubmitted: propTypes.bool.isRequired,
  className: propTypes.string
}

Checkbox.defaultProps = {
  className: ""
}

export default Checkbox
